import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useGetUser } from 'hooks';
import AGLODashboard from './components/AGLODashboard';
import SuperAdminDashboard from './components/SuperAdminDashboard';

const CONST_NONE = 'none';
const CONST_FILTER_LABEL_YEAR = 'year';

const Dashboard = () => {
  const { isAGLO, isSuperAdmin } = useGetUser();

  const [queryFilters, setQueryFilter] = useState(null);
  const [searchParams, setSearchParams] = useSearchParams();
  const [showTag, setShowTag] = useState(false);

  const preSetYear = searchParams.get(CONST_FILTER_LABEL_YEAR);

  const [selectedYear, setYear] = useState(preSetYear || CONST_NONE);

  const fetchParams = queryFilters ? { ...queryFilters } : {};

  const currentYear = new Date().getFullYear();

  // yearsArray based on current year
  // array size set to 3
  const yearsArray = Array.from({ length: 3 }, (_, i) => currentYear - 2 + i).map((year) => ({
    label: year.toString(),
    value: year.toString(),
  }));

  return (
    <>
      {isAGLO && (
        <AGLODashboard
          queryFilters={queryFilters}
          setQueryFilter={setQueryFilter}
          yearsArray={yearsArray}
          setSearchParams={setSearchParams}
          selectedYear={selectedYear}
          setYear={setYear}
          showTag={showTag}
          setShowTag={setShowTag}
          fetchParams={fetchParams}
        />
      )}
      {isSuperAdmin && (
        <SuperAdminDashboard
          queryFilters={queryFilters}
          setQueryFilter={setQueryFilter}
          yearsArray={yearsArray}
          setSearchParams={setSearchParams}
          selectedYear={selectedYear}
          setYear={setYear}
          showTag={showTag}
          setShowTag={setShowTag}
          fetchParams={fetchParams}
        />
      )}
    </>
  );
};

export default Dashboard;
